import React from 'react';
import { Brain, FileText } from 'lucide-react';


function CaseInfoTabs({currentTab, setCurrentTab}) {
  return (
   <div className="w-full flex items-center justify-center bg-ivory border-b border-[rgba(20,33,61,.1)] font-plexsans">
  <div className="inline-flex lg:w-[50%] w-full lg:flex lg:justify-center bg-ivory">

    <button
      onClick={() => setCurrentTab(1)}
      className={`flex flex-1 items-center justify-center gap-2 px-4 lg:py-5 py-3 text-[14px] font-medium transition-all duration-200 border-b-2
        ${
          currentTab === 1
            ? " text-navy border-tan"
            : "text-[rgba(20,33,61,.5)] border-transparent hover:text-navy"
        }`}
    >
      <FileText size={17} />
      <span>Case Details</span>
    </button>

    <button
      onClick={() => setCurrentTab(2)}
      className={`flex flex-1 items-center justify-center gap-2 px-4 lg:py-5 py-3 text-[14px] font-medium transition-all duration-200 border-b-2
        ${
          currentTab === 2
            ? " text-navy border-tan"
            : "text-[rgba(20,33,61,.5)] border-transparent hover:text-navy"
        }`}
    >
      <Brain size={17} />
      <span>AI Insights</span>
    </button>

  </div>
</div>
  )
}

export default CaseInfoTabs
